<!-- =========================================================================================
  File Name: UserView.vue
  Description: User View page

========================================================================================== -->

<template>
  <div id="page-user-view">

    <vs-alert v-if="errorOccurred" color="danger" title="Lesson Not Found">
      <span>Lesson record with id:  not found. </span>
      <span>
        <span>Check </span><router-link :to="{name:'management-list-lesson'}"
                                        class="text-inherit underline">All Lessons</router-link>
      </span>
    </vs-alert>

    <div v-else id="lesson-data">

      <!--- TOP DOMAIN BANNER START --->
      <div class="vx-row mb-6">
        <div class="vx-col w-full">
          <div class="knowledge-base-jumbotron bg-cover rounded-lg vx-card"
               :style="`background-image: url(${lessonData.banner})`">
            <div class="knowledge-base-jumbotron-content rounded-lg p-8 lg:p-12" style="backdrop-filter: blur(5px)">
              <div class="flex justify-between items-center ">
                <div>
                  <h1 class="text-white w-full" style="font-size: 4rem">{{ lessonData.name }}</h1>
                </div>
                <img class="rounded" :src="lessonData.thumbnail" v-if="lessonData.thumbnail" width="150px">
              </div>
            </div>
          </div>
        </div>
      </div>
      <!--- TOP DOMAIN BANNER END --->

      <!--- DOMAIN ACTION BAR START --->
      <div class="vx-row mb-6 match-height">
        <div class="vx-col grid grid-cols-4 gap-8 w-full">
          <vx-card class="bg-success-gradient p-6 cursor-pointer" @click="editLessonPopup = true">
            <div class="flex items-center justify-center">
              <feather-icon icon="EditIcon" svgClasses="h-16 w-16"/>
            </div>
            <div class="flex items-center justify-center">
              <h2 class="text-center mt-4">Edit<br>Lesson</h2>
            </div>
          </vx-card>
          <vx-card class="bg-warning-gradient p-6 cursor-pointer" @click="refreshLessonCache(lessonData.id)">
            <div class="flex items-center justify-center">
              <feather-icon icon="RefreshCwIcon" svgClasses="h-16 w-16"/>
            </div>
            <div class="flex items-center justify-center">
              <h2 class="text-center mt-4">Refresh<br>Cache</h2>
            </div>
          </vx-card>
          <vx-card class="bg-primary-gradient p-6 cursor-pointer" @click="$router.push(`/a/lessons/${lessonData.id}/builder`)">
            <div class="flex items-center justify-center">
              <feather-icon icon="ZapIcon" svgClasses="h-16 w-16"/>
            </div>
            <div class="flex items-center justify-center">
              <h2 class="text-center mt-4">Lesson<br>Builder</h2>
            </div>
          </vx-card>
          <vx-card class="bg-danger-gradient p-6 cursor-pointer" @click="confirmDeleteLesson">
            <div class="flex items-center justify-center">
              <feather-icon icon="TrashIcon" svgClasses="h-16 w-16"/>
            </div>
            <div class="flex items-center justify-center">
              <h2 class="text-center mt-4">Archive<br>Lesson</h2>
            </div>
          </vx-card>
        </div>
      </div>
      <!--- DOMAIN ACTION BAR END --->

      <!--- DOMAIN SHOW INFORMATION START--->
      <div class="vx-row mb-6 match-height">
        <div class="vx-col w-1/3">
          <vx-card class="w-full flex items-center">
            <h3 class="font-bold">Lesson Id</h3>
            <h3 class="font-light">{{ lessonData.id }}</h3>
          </vx-card>
        </div>
        <div class="vx-col w-1/3">
          <vx-card class="w-full flex items-center">
            <h3 class="font-bold">Lesson Status</h3>
            <h3 class="capitalize font-light">{{ lessonData.status }}</h3>
          </vx-card>
        </div>
        <div class="vx-col w-1/3">
          <vx-card class="w-full flex items-center">
            <h3 class="font-bold">Lesson Challenges</h3>
            <h3 class="capitalize font-light">{{ lessonData.challenges.length }}</h3>
          </vx-card>
        </div>
      </div>
      <!--- DOMAIN SHOW INFORMATION END--->

    </div>

    <vs-popup :active.sync="editLessonPopup" title="Edit Lesson" id="EditLessonPopup">
      <vs-input v-model="lessonData.name" class="mb-5 w-full" label-placeholder="Term"/>
      <vs-select class="w-full mb-10" placeholder="Lesson Status" v-model="lessonData.status">
        <vs-select-item :key="index" :value="option" :text="option.charAt(0).toUpperCase() + option.slice(1)" v-for="(option,index) in statusOptions"/>
      </vs-select>
      <vs-button color="success" type="filled" @click="editLesson">Update Lesson</vs-button>
    </vs-popup>

  </div>
</template>

<script>
import Prism from 'vue-prism-component'
import vSelect from 'vue-select'
import Datepicker from 'vuejs-datepicker'

export default {
  data () {
    return {
      lessonData: [],
      lessonDescriptionCounter: false,
      errorOccurred: false,

      editLessonPopup: false,

      statusOptions: [
        'active',
        'hidden',
        'disabled'
      ]

    }
  },
  components: {
    Prism,
    vSelect,
    Datepicker
  },
  methods: {
    fetchLessonDetails (id) {

      this.$http.get(`practice/lessons/${id}`)
        .then(response => {

          if (response.status === 200) {
            this.lessonData = response.data.data
          }

        })
        .catch(error => {
          this.errorOccurred = true
          this.error_msg = error
        })
    },
    confirmDeleteLesson () {
      this.$vs.dialog({
        type: 'confirm',
        color: 'danger',
        title: 'Confirm Archive',
        text: 'Please confirm you want to archive this lesson.',
        accept: this.deleteLesson,
        acceptText: 'Archive'
      })
    },
    deleteLesson () {
      this.$vs.loading()

      this.$http.delete(`practice/lessons/${this.$route.params.lessonId}`)
        .then(response => {
          this.$vs.loading.close()

          if (response.status === 200) {
            this.$router.push('/a/lessons')

            return this.$vs.notify({
              color: 'success',
              title: 'Lesson Archived',
              text: 'You have successfully archived this lesson',
              icon: 'feather',
              iconPack: 'icon-check-circle',
              position: 'top-right'
            })
          }
        })
        .catch(exception => {
          this.$vs.loading.close()

          let error = 'An unknown error occurred while deleting this lesson.'
          if (exception.response) {
            error = exception.response.data.error.description
          }

          return this.$vs.notify({
            color: 'danger',
            title: 'Failed to Delete Group',
            text: error,
            icon: 'feather',
            iconPack: 'icon-x-circle',
            position: 'top-right'
          })
        })
    },
    refreshLessonCache (id) {
      this.$vs.loading()

      this.$http.get(`practice/lessons/${id}/cache`)
        .then(response => {
          this.$vs.loading.close()

          if (response.status === 200) {
            return this.$vs.notify({
              color: 'success',
              title: 'Cache Cleared',
              text: 'The lesson cache has been cleared successfully',
              icon: 'feather',
              iconPack: 'icon-check-circle',
              position: 'top-right'
            })
          }

        })
        .catch(() => {
          this.$vs.loading.close()
          return this.$vs.notify({
            color: 'danger',
            title: 'Failed to Clear Cache',
            text: 'The lesson cache was not cleared successfully',
            icon: 'feather',
            iconPack: 'icon-x-circle',
            position: 'top-right'
          })
        })
    },
    editLesson () {
      const pl = {
        name: this.lessonData.name,
        status: !this.lessonData.status ? 'active' : this.lessonData.status
      }
      this.$http.post(`practice/lessons/${this.lessonData.id}`, pl)
        .then(response => {
          this.editLessonPopup = false
          if (response.status === 200) {
            this.$vs.loading.close()
            this.$vs.notify({
              title: 'Updated Lesson Successfully',
              text: `Set ${pl.name} has been updated.`,
              color: 'success',
              position: 'top-right'
            })
            this.fetchLessonDetails(response.data.data.id)
          }
        })
        .catch(exception => {
          this.$vs.loading.close()
          let error = 'An unknown error occurred while updating this lesson'
          if (exception.response) {
            error = exception.response.data.error.description
          }
          return this.$vs.notify({
            title: 'Failed to update lesson',
            text: error,
            color: 'danger',
            position: 'top-right'
          })
        })
    }
  },
  created () {
    this.fetchLessonDetails(this.$route.params.lessonId)
  }
}

</script>

<style lang="scss">
#avatar-col {
  width: 10rem;
}

.theme-midnight {
  #EditLessonPopup {
    input {
      background: #050056 !important;
      border: 1px solid #ffffff !important;

      &:focus {
        border: 1px solid rgba(var(--vs-primary), 1) !important;
      }
    }
  }
}

.theme-dark {
  #EditLessonPopup {
    input {
      background: #1B1E22 !important;
      border: 1px solid #ffffff !important;

      &:focus {
        border: 1px solid rgba(var(--vs-primary), 1) !important;
      }
    }
  }
}

#page-user-view {

  table {
    td {
      vertical-align: top;
      min-width: 140px;
      padding-bottom: .8rem;
      word-break: break-all;
    }

    &:not(.permissions-table) {
      td {
        @media screen and (max-width: 370px) {
          display: block;
        }
      }
    }
  }

  @media (min-width: 1200px) and (max-width: 1700px) {
    .image-lesson {
      display: none;
    }
    .lesson-col {
      width: 0 !important;
      min-height: 2.05vh;
    }
    .welcome-col {
      width: 100% !important;
    }
  }
}

.datepicker-user-popup {
  .vdp-datepicker__calendar {
    width: 100%;
    padding: 5px 0 10px 0;
  }


  span.cell.day {
    border-radius: 5%;
    margin-bottom: 0.5%;
    margin-top: 0.5%;
  }

  span.cell.day.today {
    border-radius: 5%;
    color: #fff;
    background: rgba(var(--vs-primary), 0.1);

    &:hover {
      background: rgba(var(--vs-primary), 0.2);
    }
  }


}
</style>
